/* RESPONSIBLE TEAM: team-frontend-tech */
import { A } from '@ember/array';
import BlockSerializer from './block';

const OPTIONAL_STYLE_ATTRIBUTES = A(['fontFamily']);

export default BlockSerializer.extend({
  optionalAttributes: OPTIONAL_STYLE_ATTRIBUTES,
});
